function t(o, e) {
  var a = e.value, i = e.selectionStart, n = e.selectionEnd;
  a !== void 0 && (o.value = a), i !== void 0 && n !== void 0 && o.setSelectionRange(i, n);
}
export {
  t as default
};
//# sourceMappingURL=setInputAttributes.js.map
